import useContentModal from "./useContentModal";

const useResourceModal = () => {
  const { modalState, shouldUseModal, openContent, closeModal } =
    useContentModal("resources");

  // Map the generic content methods to resource-specific names for backward compatibility
  const openResource = (resourceId, navigate) => {
    openContent(resourceId, navigate);
  };

  return {
    modalState: {
      isOpen: modalState.isOpen,
      resourceId: modalState.contentId, // Map contentId to resourceId for backward compatibility
    },
    shouldUseModal,
    openResource,
    closeModal,
  };
};

export default useResourceModal;
